import { BarsChart } from "@nymbl/nos2-rules/charts";
import type { UseQueryResult } from "@tanstack/react-query";
import { useMemo } from "react";
import { formatPercent, trendRows } from "@/lib/month/metrics";
import { formatHours } from "@/lib/time/rules";
import type { MonthSummaryView } from "@/schemas/month";

/** Six months ending at the selected one; % = productive / (capacity - PTO). */
export function TrendPanel({ query }: { query: UseQueryResult<MonthSummaryView> }) {
  const rows = useMemo(() => trendRows(query.data?.months ?? [], formatPercent), [query.data]);
  return (
    <BarsChart
      title="Utilization, last 6 months"
      rows={rows}
      x="label"
      xLabel="Month"
      series={[
        { key: "productive", label: "Productive", slot: 1 },
        { key: "pto", label: "PTO", slot: 4 },
      ]}
      mode="stacked"
      format={(value) => `${formatHours(value)} hrs`}
      axisFormat={(value) => formatHours(value)}
      loading={query.isPending}
      error={query.error}
      onRetry={() => void query.refetch()}
      headingLevel={2}
    />
  );
}
